export function getImage(images, index) {
  const image = images[index]
  return typeof image === 'object' ? image.src : image // Fallback to legacy code
}

export function getPrimaryImage(images) {
  const primaryImage = images.find(image => image.tag === 'primary') || images[0]
  return typeof primaryImage === 'object' ? primaryImage.src : primaryImage // Fallback to legacy code
}

export function isGiftcard(product) {
  return product.permalink.includes('giftcard')
}

export function getSizes(products) {
  return products.reduce((productSizes, product) => {
    const variantSizes = product.variants.reduce(
      (variantSizes, variant) =>
        productSizes.includes(variant.abbreviated_size)
          ? variantSizes
          : [...variantSizes, variant.abbreviated_size],
      [],
    )

    return [...productSizes, ...variantSizes]
  }, [])
}

const sizeSplitRegex = /(?=M)/

// Our sneaker sizes are unisex and, as such, formatted like `W5M9`. Alas, we
// only want to show the size for the product gender, so we reformat with this
// method. It will take `W5M9` and return either `W 5` or `M 9`, depending on gender.
export function getSneakersGenderedSizeName(size, gender) {
  const sizeChunkToKeep = gender === 'male' ? 1 : 0
  let formattedSize = size
  if (size.split(sizeSplitRegex).length === 2) {
    formattedSize = size
      .split(sizeSplitRegex)
      [sizeChunkToKeep].split(/(\d+)/)
      .join(' ')
      // Doing this hacky replacement here because this method might be passed
      // old size names that contain `F` instead of `W` from old reviews.
      .replace('F', 'W')
      .trim()
  }

  // remove unwanted spaces for half-sizes
  if (formattedSize.startsWith('W') || formattedSize.startsWith('M')) {
    const removeSpacesFromSize = formattedSize.substring(1).replace(/\s/g, '')
    const genderAbbrev = formattedSize.substring(0, 1)
    return `${genderAbbrev} ${removeSpacesFromSize}`.trim()
  }
  return formattedSize
}

export function getPromoMessageCopy(product, location) {
  if (!product || !product.promotion_messages) {
    return null
  }

  const promotionMessages =
    product.promotion_messages.filter(message => message.location === location) || []

  if (promotionMessages.length > 0) {
    return promotionMessages[0].promo_text
  }

  return null
}
